/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Content from "../../../../../layout/content/Content";

import { Doughnut } from "react-chartjs-2";
import {
    Block,
    BlockDes,
    BlockHead,
    Col,
    Row,
    PreviewAltCard,
    Button,
    Icon,
} from "../../../../../components/Component";
import { Spinner } from 'reactstrap'
import Head from "../../../../../layout/head/Head";
import OptionC from "../../../../components/DynmicOption/OptionC";
import ERDataUpdate from "./ERDataUpdate";

const ERDashboard = ({ ...props }) => {
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const today = new Date();
    const [data, setData] = useState();
    const [formData, setFormData] = useState({
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: -1,

    });
    const [userData, setuserData] = useState(null);   
    const [Edit, setEdit] = useState({
        edit: 0,
        submit: 0,
        open: 0
    })
    const [data2, setdata2] = useState({
        labels: ["Deaft", "Submitted", "Open"],
        dataUnit: "People",
        legend: false,
        datasets: [
            {
                borderColor: "#fff",
                backgroundColor: ["#f9db7b", "#1ee0ac", "#e85347",],
                data: [2, 2, 2],
            },
        ],
    })
    const tableRef = useRef(null);
    const getdata = async () => {
        const sendData = {

            EmploymentRefIdEr: Number(formData.EmploymentRefId),
        }

        ////console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/ER/GetparametersNumber', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    setData(data)
                })


    };

    const getdata2 = async () => {

        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            MonthId: Number(formData.month),
            EmploymentRefIdEr: formData.EmploymentRefId,
            YearId: Number(formData.year),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/ER/Dashdatacount', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                   // //console.log(data)
                    setEdit({
                        edit: data.edit,
                        submit: data.submit,
                        open: data.open
                    })
                    setdata2({
                        labels: ["Draft", "Submitted", "Open"],
                        dataUnit: "People",
                        legend: false,
                        datasets: [
                            {
                                borderColor: "#fff",
                                backgroundColor: ["#f9db7b", "#1ee0ac", "#e85347",],
                                data: [data.edit, data.submit, data.open],
                            },
                        ],
                    })
                })


    };
    const usergetdata = async () => {


        const sendData = {
            UserId: Number(localStorage.getItem("userId")),

        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Payment/Getuser', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    ////console.log(data)
                    setuserData(data)

                })


    };

    const onInputChange = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };
    useEffect(() => {
        getdata()
        usergetdata()
    }, [])


    useEffect(() => {
        getdata2()

    }, [formData.month, formData.year])






    return (
        <React.Fragment>
            <Head title="AllUser" />

            <Content>
                
                {localStorage.getItem("urole") !== "16" ?
                    <Button onClick={() => window.location.href = '/ERRegionaldashboard'} style={{ marginBottom: 20 }} color='success'> <Icon name="arrow-left" />  Back To ER Regional Dashboard</Button> : null}


                <Block>

                    <BlockHead size="lg">

                        <BlockDes className="text-soft">

                            <Row >

                                <Col xl="2" md="2">
                                    <td >
                                        <h5 style={{ color: '#798bff' }}>ER Dashboard</h5>
                                    </td>
                                </Col> <Col xl="3" md="3">
                                    <td >
                                        <label style={{ color: 'black', fontSize: 15 }}>  Exchange :  <label style={{ fontWeight: 'bold' }}>{userData != null ? userData.answer1 : null}</label></label>
                                    </td>
                                </Col>
                                <Col xl="2" md="2" >

                                    <label style={{ color: 'black', fontSize: 15 }}>  Center :  <label style={{ fontWeight: 'bold' }}> {userData != null ? userData.state : null}</label></label>
                                </Col>
                                <Col xl="2" md="2" >
                                    <label style={{ color: 'black', fontSize: 15 }}>   <label style={{ fontWeight: 'bold' }}><OptionC defaultValuemain={formData.year} catid="42" onInputChange={onInputChange} namemain="year" mainid="year" /></label></label>


                                </Col>
                                
                            </Row>
                            <hr />
                            <Row>
                                <Col md="4" xxl="4">
                                    <PreviewAltCard border1={true} className="h-100">
                                        <h6 className="ff-base fw-medium"><b style={{ fontSize: 20 }}>  Summary</b> :<br /><br /> <small className="text-soft">The ER dashboard shows the data of employment exchange of a particular month

                                        </small></h6>
                                    </PreviewAltCard>
                                </Col>
                                <Col md="8" xxl="8">
                                    <PreviewAltCard border1={true} className="h-100">
                                        <Row>
                                            <Col md="2"></Col>
                                            <Col md="6">
                                                <div className="traffic-channel-group">

                                                    <div >
                                                        <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#f9db7b" }}></span>
                                                            <b style={{ fontSize: 20 }}> Draft : <large style={{ marginLeft: 80 }}> {Edit.edit}</large> </b>
                                                        </div>
                                                        <div className="amount">

                                                        </div>
                                                    </div>

                                                    <div >
                                                        <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#1ee0ac" }}></span>
                                                            <b style={{ fontSize: 20 }}> Submitted : <large style={{ marginLeft: 32 }}> {Edit.submit}</large></b>
                                                        </div>
                                                        <div className="amount">

                                                        </div>
                                                    </div>
                                                    <div >
                                                        <div className="title">
                                                            <span className="dot dot-lg sq" style={{ background: "#e85347" }}></span>
                                                            <b style={{ fontSize: 20 }}> Open  : <large style={{ marginLeft: 77 }}> {Edit.open}</large></b>
                                                        </div>
                                                        <div className="amount">

                                                        </div>
                                                    </div>

                                                </div>
                                            </Col>
                                            <Col md="4">
                                                <div className="traffic-channel-doughnut-ck">
                                                    <Doughnut
                                                        className="analytics-doughnut"
                                                        data={data2}
                                                        options={{
                                                            legend: {
                                                                display: false,
                                                            },
                                                            rotation: -1.5,
                                                            cutoutPercentage: 70,
                                                            maintainAspectRatio: false,
                                                            tooltips: {
                                                                enabled: true,
                                                                backgroundColor: "#fff",
                                                                borderColor: "#eff6ff",
                                                                borderWidth: 2,
                                                                titleFontSize: 13,
                                                                titleFontColor: "#6783b8",
                                                                titleMarginBottom: 6,
                                                                bodyFontColor: "#9eaecf",
                                                                bodyFontSize: 12,
                                                                bodySpacing: 4,
                                                                yPadding: 10,
                                                                xPadding: 10,
                                                                footerMarginTop: 0,
                                                                displayColors: false,
                                                            },
                                                        }}
                                                    ></Doughnut>
                                                </div>

                                            </Col>
                                        </Row>
                                    </PreviewAltCard>

                                </Col>
                            </Row>
                        </BlockDes>


                    </BlockHead>


                    <div className="table-responsive">
                        <table className="table table-orders" ref={tableRef}>
                            <thead className="tb-odr-head">
                                <tr className="tb-odr-item" >
                                    <th >
                                        S.No

                                    </th>
                                    <th >
                                        Form Name

                                    </th>
                                    <th  >
                                        Status

                                    </th>
                                    <th >
                                        Action

                                    </th>



                                </tr>


                            </thead>

                            {data !== undefined ? data.map((item, index) => {
                                return (

                                    <ERDataUpdate sno={item.sno} name={item.name} month={formData.month} path={item.apikey1} path2={item.apikey2} year={formData.year} parent={item.parentId} ERDataUpdate={ERDataUpdate} />
                                   

                                );
                            }) : <Spinner color="success"/>}


                        </table>

                    </div>




                </Block>




            </Content>

        </React.Fragment>
    );
};

export default ERDashboard;
